export default __webpack_public_path__ + "static/media/NusLogo.965fac07.png";